<template>
    <div class="pop_login" v-if="visible" @click="closeModal" :style="{ zIndex: zIndex }">
        <div class="login_box" @click.stop="aaa">
            <div class="log_head" v-if="login_type_i != 3">
                <div class="loghe">
                    <div :class="log_i == 1 ? 'active' : ''" @click.stop="logBtn('1')">
                        登录
                    </div>
                    <div :class="log_i == 2 ? 'active' : ''" @click.stop="logBtn('2')">
                        注册
                    </div>
                </div>
                <i @click="closeModal" class="el-icon-circle-close"
                    style="color: #333333;width: 20px;height: 20px;"></i>
            </div>
            <div class="log_head" v-else>
                <p style="width: 20px;height: 20px;"></p>
                <div class="sdsd">重置密码</div>
                <i @click="closeModal" class="el-icon-circle-close"
                    style="color: #333333;width: 20px;height: 20px;"></i>
            </div>

            <div class="log_cen" v-if="login_type_i == 1">
                <div class="cen_li">
                    <input type="text" placeholder="请输入手机号" v-model="phones" />
                </div>
                <div class="cen_li" v-if="log_i == 2">
                    <input type="text" placeholder="请输入验证码" v-model="codes" />
                    <div class="" @click="toCode()">{{ msgText }}</div>
                </div>
                <div class="cen_li">
                    <input :type="showPassword1 ? 'text' : 'password'" placeholder="密码" v-model="pwds" />
                    <img :src="showPassword1 ? require('@/static/imgs/eye_zheng.png') : require('@/static/imgs/eye_bi.png')"
                        alt="" @click="togglePassword1" style="cursor: pointer;">
                </div>

                <div class="yuedu" @click="flag = !flag">
                    <img v-if="flag" src="../static/imgs/sele_yes.png" alt="">
                    <img v-else src="../static/imgs/sele_no.png" alt="">
                    <p class="">请已阅读并同意<span @click.stop="toNav('1')">《用户服务协议》</span>与<span
                            @click.stop="toNav('2')">《隐私协议》</span></p>
                </div>
                <div class="cen_foot" @click.stop="toLogin()" v-if="log_i == 1">登录</div>
                <div class="cen_foot" @click.stop="toReg()" v-if="log_i == 2">注册</div>

                <div class="log_text" v-if="log_i == 1">
                    <p @click="toType('3')">忘记密码？</p>
                    <p @click="toType('2')">手机号登录</p>
                </div>
                <div class="log_tip" v-if="log_i == 1">其他方式登录</div>
                <div class="log_img" v-if="log_i == 1">
                    <img @click="getWxLogin()" src="../static/imgs/login_wx.png" alt="">
                </div>
            </div>

            <div class="log_cen" v-if="login_type_i == 2">
                <div class="cen_li">
                    <input type="text" placeholder="请输入手机号" v-model="phones" />
                </div>
                <div class="cen_li">
                    <input type="text" placeholder="请输入验证码" v-model="codes" />
                    <div class="" @click="toCode()">{{ msgText }}</div>
                </div>

                <div class="yuedu" @click="flag = !flag">
                    <img v-if="flag" src="../static/imgs/sele_yes.png" alt="">
                    <img v-else src="../static/imgs/sele_no.png" alt="">
                    <p class="">请已阅读并同意<span @click.stop="toNav('1')">《用户服务协议》</span>与<span
                            @click.stop="toNav('2')">《隐私协议》</span></p>
                </div>
                <div class="cen_foot" @click.stop="toPhoneLogin()" v-if="log_i == 1">登录</div>

                <div class="log_text" v-if="log_i == 1">
                    <p></p>
                    <p @click="toType('1')">密码登录</p>
                </div>
                <div class="log_tip" v-if="log_i == 1">其他方式登录</div>
                <div class="log_img" v-if="log_i == 1">
                    <img @click="getWxLogin()" src="../static/imgs/login_wx.png" alt="">

                </div>
            </div>

            <div class="log_cen" v-if="login_type_i == 3">
                <div class="cen_li">
                    <input type="text" placeholder="请输入手机号" v-model="phones" />
                </div>
                <div class="cen_li">
                    <input type="text" placeholder="请输入验证码" v-model="codes" />
                    <div class="" @click="toCode()">{{ msgText }}</div>
                </div>
                <div class="cen_li">
                    <input :type="showPassword2 ? 'text' : 'password'" placeholder="密码" v-model="pwds" />
                    <img :src="showPassword2 ? require('@/static/imgs/eye_zheng.png') : require('@/static/imgs/eye_bi.png')"
                        alt="" @click="togglePassword2" style="cursor: pointer;">
                </div>

                <div class="yuedu" @click="flag = !flag">
                    <img v-if="flag" src="../static/imgs/sele_yes.png" alt="">
                    <img v-else src="../static/imgs/sele_no.png" alt="">
                    <p class="">请已阅读并同意<span @click.stop="toNav('1')">《用户服务协议》</span>与<span
                            @click.stop="toNav('2')">《隐私协议》</span></p>
                </div>
                <div class="cen_foot" @click.stop="toForget()">确定</div>

                <div class="log_text" v-if="log_i == 1">
                    <p></p>
                    <p @click="toType('1')">密码登录</p>
                </div>
                <div class="log_tip" v-if="log_i == 1">其他方式登录</div>
                <div class="log_img" v-if="log_i == 1">
                    <img @click="getWxLogin()" src="../static/imgs/login_wx.png" alt="">
                </div>
            </div>
        </div>
    </div>
</template>

<script src="http://res.wx.qq.com/connect/zh_CN/htmledition/js/wxLogin.js"></script>

<script>
var clear;
export default {
    name: 'LoginModal',
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        type: {
            type: String,
            default: 'login' // login, register
        },
        zIndex: {
            type: Number,
            default: 9999
        }
    },
    data() {
        return {
            login_flag: false,
            login_type_i: 1,
            log_i: 1,
            phones: '',
            codes: '',
            pwds: '',
            flag: false,
            msgText: '验证码',
            readonlyFlag: false,
            timer: null,
            countdown: 60,
            showPassword1: false,
            showPassword2: false,
            showQrcode: false, // 初始不显示

            code: '',

            regist_obj:''
        }
    },
    watch: {
        visible(newVal) {
            if (newVal) {
                this.initModal()
            }
        },
        type(newVal) {
            if (newVal === 'register') {
                this.log_i = 2
            } else {
                this.log_i = 1
            }
        }
    },
    mounted() {
        // this.getCode()
    },
    methods: {
        getWxLogin() {
            if (!this.code) {
                // 不存在， 配置相关微信登录参数（ 主要是授权页面地址， appID， 回调地址） ''
                window.location.href = `https://open.weixin.qq.com/connect/qrconnect?appid=wxb683a875aef8662d&redirect_uri=${encodeURIComponent("https://icmn.cn/#/")}&response_type=code&scope=snsapi_login&state=Math.random()#wechat_redirect`
            }
        },
        // getCode() {
        //     this.code = this.$route.query.code
        //     // console.log( this.code)

        //     if (this.code) {
        //         this.$http("/api/account/getOpenId", {
        //             code: this.code,
        //             type:'PC'
        //         }, 'GET').then((res) => {
        //             if (res.code == 200) {
        //                 sessionStorage.setItem('token', res.data.token)
        //                 this.$message.success('登录成功')
        //                 this.closeModal();
        //                 // 登录成功后刷新当前页面
        //                 window.location.reload();
        //             } else if(res.code==201){
        //                 this.regist_obj = res.data
        //             } else {
        //                 this.$message.error(res.msg)
        //             }
        //         })
        //     }
        // },



        initModal() {
            this.phones = ''
            this.codes = ''
            this.pwds = ''
            this.flag = false
            this.msgText = '验证码'
            this.showPassword1 = false
            this.showPassword2 = false
            if (this.type === 'register') {
                this.log_i = 2
            } else {
                this.log_i = 1
            }
        },
        aaa() { },
        closeModal() {
            console.log('关闭弹窗')
            this.$emit('close')
        },
        logBtn(type) {
            this.log_i = type
        },
        toType(typer) {
            this.login_type_i = typer
        },
        toNav(typer) {
            this.closeModal();
            
            this.$router.push({
                path: "/texts",
                query: {
                    type: typer,
                    times: (new Date()).getTime()
                },
            });
        },
        toCode() {
            if (this.readonlyFlag) return;
            if (this.phones == '') return this.$message.error('请输入手机号');
            this.$http("/api/account/sendCode", {
                phone: this.phones
            }, 'GET').then((res) => {
                if (res.code == 200) {
                    this.$message.success('成功');
                    this.get_code();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //验证码按钮文字状态
        get_code() {
            clear && clearInterval(clear);
            const _this = this;
            this.readonlyFlag = true;
            this.msgText = '60S';
            var s = 60;
            clear = setInterval(() => {
                s--;
                _this.msgText = s + 'S';
                if (s <= 0) {
                    clearInterval(clear);
                    _this.msgText = '获取验证码';
                    _this.readonlyFlag = false;
                }
            }, 1000);
        },
        //登录
        toLogin() {
            if (this.phones == '') return this.$message.error('请输入登录账号')
            if (this.pwds == '') return this.$message.error('请输入登录密码')
            if (!this.flag) return this.$message.error('请已阅读并同意《用户服务协议》与《隐私协议》')

            console.log('开始登录请求...')
            this.$http('/api/account/login', {
                phone: this.phones,
                password: this.pwds
            }, 'GET').then(res => {
                console.log('登录响应:', res)
                if (res.code == 200) {
                    sessionStorage.setItem('token', res.data.token)
                    this.$message.success('登录成功')
                    this.closeModal();
                    // 登录成功后刷新当前页面
                    window.location.reload();
                } else {
                    this.$message.error(res.msg || '登录失败')
                }
            }).catch(err => {
                console.error('登录错误:', err)
                this.$message.error('登录失败，请检查网络连接')
            })
        },
        toPhoneLogin() {
            if (this.phones == '') return this.$message.error('请输入登录账号')
            if (this.codes == '') return this.$message.error('请输入验证码')
            if (!this.flag) return this.$message.error('请已阅读并同意《用户服务协议》与《隐私协议》')
            this.$http('/api/account/login', {
                phone: this.phones,
                code: this.codes
            }, 'GET').then(res => {
                if (res.code == 200) {
                    sessionStorage.setItem('token', res.data.token)
                    this.$message.success('登录成功')
                    this.closeModal();
                    // 登录成功后刷新当前页面
                    window.location.reload();
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        //注册
        toReg() {
            if (this.phones == '') return this.$message.error('请输入登录账号')
            if (this.pwds == '') return this.$message.error('请输入登录密码')
            if (this.codes == '') return this.$message.error('请输入验证码')
            if (!this.flag) return this.$message.error('请已阅读并同意《用户服务协议》与《隐私协议》')

            console.log('开始注册请求...')
            this.$http('/api/account/register', {
                phone: this.phones,
                code: this.codes,
                password: this.pwds,
                userType:1
            }).then(res => {
                console.log('注册响应:', res)
                if (res.code == 200) {
                    clear && clearInterval(clear);

                    this.msgText = '验证码'
                    this.codes = ''
                    this.$message.success('注册成功')
                    this.log_i = 1;
                    this.phones = '';
                    this.pwds = '';



                } else {
                    this.$message.error(res.msg || '注册失败')
                }
            }).catch(err => {
                console.error('注册错误:', err)
                this.$message.error('注册失败，请检查网络连接')
            })
        },
        //忘记密码
        toForget() {
            if (this.phones == '') return this.$message.error('请输入登录账号')
            if (this.pwds == '') return this.$message.error('请输入登录密码')
            if (this.codes == '') return this.$message.error('请输入验证码')
            this.$http('/api/account/update', {
                phone: this.phones,
                code: this.codes,
                password: this.pwds
            }).then(res => {
                if (res.code == 200) {
                    this.log_i = 1;
                    this.phones = '';
                    this.pwds = '';
                    this.codes = '';
                }
            })
        },
        // 切换第一个密码框显示/隐藏
        togglePassword1() {
            this.showPassword1 = !this.showPassword1
        },
        // 切换第二个密码框显示/隐藏
        togglePassword2() {
            this.showPassword2 = !this.showPassword2
        }
    },
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer)
        }
        if (clear) {
            clearInterval(clear)
        }
    }
}
</script>

<style scoped lang="scss">
.pop_login {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;

    .login_box {
        width: 400px;
        background: #FFFFFF;
        border-radius: 10px;
        padding: 20px;
        box-sizing: border-box;

        .log_head {
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 20px;

            .loghe {
                display: flex;
                align-items: center;

                div {
                    padding: 10px 20px;
                    cursor: pointer;
                    border-bottom: 2px solid transparent;

                    &.active {
                        color: #FF8502;
                        border-bottom-color: #FF8502;
                    }
                }
            }
        }

        .log_cen {
            .cen_li {
                position: relative;
                margin-bottom: 15px;

                input {
                    width: 100%;
                    height: 40px;
                    border: 1px solid #ddd;
                    border-radius: 5px;
                    padding: 0 15px;
                    box-sizing: border-box;
                }

                div {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #FF8502;
                    cursor: pointer;
                }

                img {
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translateY(-50%);
                    width: 20px;
                    height: 20px;
                    cursor: pointer;
                }
            }

            .yuedu {
                display: flex;
                align-items: center;
                margin-bottom: 20px;

                img {
                    width: 20px;
                    height: 20px;
                    margin-right: 10px;
                    cursor: pointer;
                }

                p {
                    font-size: 14px;
                    color: #666;

                    span {
                        color: #FF8502;
                        cursor: pointer;
                    }
                }
            }

            .cen_foot {
                width: 100%;
                height: 40px;
                background: #FF8502;
                color: #FFFFFF;
                border-radius: 5px;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                margin-bottom: 15px;
            }

            .log_text {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;

                p {
                    color: #FF8502;
                    cursor: pointer;
                    font-size: 14px;
                }
            }

            .log_tip {
                text-align: center;
                color: #999;
                font-size: 14px;
                margin-bottom: 15px;
            }

            .log_img {
                text-align: center;

                img {
                    width: 40px;
                    height: 40px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>